import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_2 = { class: "fs-12 fw-medium" }
const _hoisted_3 = { "aria-label": "Page navigation" }
const _hoisted_4 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, " Mostrando " + _toDisplayString(_ctx.showingFrom) + " - " + _toDisplayString(_ctx.showingTo) + " de " + _toDisplayString(_ctx.totalItems) + " registros ", 1 /* TEXT */),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
        }, [
          _createElementVNode("a", {
            class: "page-link icon",
            href: "#",
            "aria-label": "Previous",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1 /* HOISTED */)
          ]))
        ], 2 /* CLASS */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            key: page,
            class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
          }, [
            _createElementVNode("a", {
              class: "page-link",
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
            }, _toDisplayString(page), 9 /* TEXT, PROPS */, _hoisted_5)
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
        }, [
          _createElementVNode("a", {
            class: "page-link icon",
            href: "#",
            "aria-label": "Next",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1 /* HOISTED */)
          ]))
        ], 2 /* CLASS */)
      ])
    ])
  ]))
}